import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import moment from "moment";
import Repo from "../../../Repository/Repo";

const initialState = {
  purchaseLedgers: [],
  purchaseRemaining: 0,
  saleLedgers: [],
  saleRemaining: 0,
  loading: false,
  error: "",
};

export const getBalanceSheet = createAsyncThunk(
  "sheet/fetchSheet",
  (start, end) => {
    let today = moment().format("DD-MM-YYYY");
    return Repo.ledger({
      request: {
        method: "getBalanceSheet",
        data: {
          company_code: localStorage.getItem("companyCode"),
          startDate: start && end ? moment(start).format("DD-MM-YYYY") : today,
          endDate: start && end ? moment(end).format("DD-MM-YYYY") : today,
        },
      },
    })
      .then(({ data }) => data.response.data)
      .catch((err) => console.log(err));
  }
);

export const balanceSheet = createSlice({
  name: "sheet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getBalanceSheet.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getBalanceSheet.fulfilled, (state, action) => {
      const { purchaseLedgers, purchaseRemaining, saleLedgers, saleRemaining } =
        action.payload;
      state.loading = false;
      state.purchaseLedgers = purchaseLedgers;
      state.purchaseRemaining = purchaseRemaining;
      state.saleLedgers = saleLedgers;
      state.saleRemaining = saleRemaining;
      state.error = "";
    });
    builder.addCase(getBalanceSheet.rejected, (state, action) => {
      state.loading = false;
      state.purchaseLedgers = [];
      state.saleLedgers = [];
      state.purchaseRemaining = 0;
      state.saleRemaining = 0;
      state.error = action.error.message;
    });
  },
});

export const {} = balanceSheet.actions;

export default balanceSheet.reducer;
